import { render, staticRenderFns } from "./textareaMaterialWrap.vue?vue&type=template&id=0646159e&"
import script from "./textareaMaterialWrap.vue?vue&type=script&lang=js&"
export * from "./textareaMaterialWrap.vue?vue&type=script&lang=js&"
import style0 from "./textareaMaterialWrap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports